import { createModel } from "hox";
import { ISupplierSearch, ISupplierParams, ISupplierDetail, ISupplierInsert, ISupplierUpdata, ISupplierDisable } from "./supplierTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption, forFind } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { supplierService } from "./supplierService"
import useMdmModel from "../../../model/mdmModel"
import moment, { Moment } from "moment";
import { useGlobalModel } from "../../../model/globalModel"
import { ShareShop, ShareUser } from "../customer/customerTypes";

export const useSupplierModel = createModel(function () {
    const { mdmOrgan } = useMdmModel();
    const { user } = useGlobalModel();
    const initSearchParams: ISupplierParams = {}
    const initDataSource: ISupplierDetail[] = []
    const initAddParam: ISupplierInsert = { enable: true, branch: "main" }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<ISupplierParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<ISupplierDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<ISupplierDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<ISupplierInsert>(initAddParam);
    //银行类型
    const [bankList, setBankList] = useState<Optios[]>([])
    //客户类型
    const [supplierList, setSupplierList] = useState<Optios[]>([])
    //门店共享
    const [shopModel, setShopModel] = useState<boolean>(false)
    const [userModel, setUserModel] = useState<boolean>(false)

    const upDataSearchParam = (upDataParam: ISupplierParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: ISupplierParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await supplierService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }

    //用于门店共享，在有条件时， 选中复合条件的所有数据
    const checkLoadData = async () => {
        const params = {
            ...searchParam,
            page: {
                pageSize: 999999,
                pageNum: 1
            }
        };
        const { retData: { records, ...pg } } = await supplierService.page(params);
        records && setSelectedRow(records);
        return records;
    }

    const updataAddParam = (updateParam: ISupplierInsert) => {
        let newUpdateParam = updateParam
        if ("categoryCode" in updateParam) {
            let findItem = findOption(updateParam.categoryCode as string, supplierList)
            newUpdateParam = { ...updateParam, categoryName: findItem?.label, categoryNameEn: findItem?.nameEn }
        }
        if ("orgCode" in updateParam) {
            let findItem = forFind(mdmOrgan, updateParam.orgCode as string, "code")
            newUpdateParam = { ...updateParam, orgName: findItem?.name as string }
        }
        // if ("bankCode" in updateParam) {
        //     let findItem = findOption(updateParam.bankCode as string, bankList)
        //     newUpdateParam = { ...updateParam, bank: findItem?.label }
        // }
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: ISupplierDetail) => {
        let newUpdateParam = updateParam
        if ("categoryCode" in updateParam) {
            let findItem = findOption(updateParam.categoryCode as string, supplierList)
            newUpdateParam = { ...updateParam, categoryName: findItem?.label, categoryNameEn: findItem?.nameEn }
        }
        if ("orgCode" in updateParam) {
            let findItem = forFind(mdmOrgan, updateParam.orgCode as string, "code")
            newUpdateParam = { ...updateParam, orgName: findItem?.name as string }
        }
        // if ("bankCode" in updateParam) {
        //     let findItem = findOption(updateParam.bankCode as string, bankList)
        //     newUpdateParam = { ...updateParam, bank: findItem?.label }
        // }
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: ISupplierInsert) => {
        const param = {
            ...addParam,
            ...params,
            sourceApp: "mian",
            enable: addParam.enable ? 1 : 0,
            createUser: user.createUser
        }
        const { retData, retMsg } = await supplierService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: ISupplierDetail) => {
        const param = {
            ...selectedRow[0],
            ...params,
            sourceApp: "mian",
            enable: selectedRow[0].enable ? 1 : 0,
            updateUser: user.updateUser
        }
        const { retData, retMsg } = await supplierService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: ISupplierDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0,
        }
        const { retData, retMsg } = await supplierService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    const onShareShop = async (params: ShareShop) => {
        const { retData, retMsg } = await supplierService.shareShop(params)
        await loadData()
        return retData
    }
    const onShareUser = async (params: ShareUser) => {
        const { retData, retMsg } = await supplierService.shareUser(params)
        await loadData()
        return retData
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        addParam,
        bankList,
        supplierList,
        setSearchParam,
        setDataSource,
        setPage,
        checkLoadData,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setBankList,
        setSupplierList,
        shopModel, setShopModel,
        userModel, setUserModel,
        onShareShop,
        onShareUser
    }
});